import type { HomepageCitySelectorParams, HomepageCitySelectorReturn } from '../types';

export default function (params: HomepageCitySelectorParams): HomepageCitySelectorReturn {
  const { name, _editable, _uid, component, placeholder } = params;
  return {
    module: 'HomepageCitySelector',
    name,
    component,
    _editable,
    _uid,
    placeholder
  };
}
